module.exports = __webpack_public_path__ + "c_static/img/还远定位.dc9cbac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/完善资料/还远定位.jpg
// module id = ozWg
// module chunks = 33